<template>
  <div class="layer setPageLayer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <div class="pageList">
        <div class="pageSearch mb10">
          <input type="text" class="input searchInput" v-model="searchWord">
        </div>
        <div class="checkbox mb5">
          <input type="checkbox" id="check_page_all" @change="checkAll">
          <label for="check_page_all">{{locale.all}}</label>
        </div>
        <div class="searchResult">
          <ul v-if="pageList.length > 0" class="list">
            <li v-for="page in pageList" :key="page.pageData.id">
              <span class="checkbox">
                <input type="checkbox" :name="`${id}_pagelist`" :id="`${id}_page_${page.pageData.id}`" :value="page.pageData.id" v-model="checkedPage">
                <label :for="`${id}_page_${page.pageData.id}`" :class="{invalid: !page.pageData.submit.isValid}">
                  <span class="name">{{page.pageData.title}}</span>
                  <p v-if="page.pageData.submit.isSubmit" class="submitTo"><span class="stkr">&#8644;</span> {{page.pageData.submit.submitLabel}}</p>
                </label>
              </span>
            </li>
          </ul>
          <div v-else class="message">{{locale.link_page_nodata}}</div>
        </div>
        <div class="btns mt30">
          <button type="button" class="btn btnWhite" @click="close">{{locale.cancel}}</button>
          <button type="button" class="btn btnPrimary" @click="apply">{{locale.confirm}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'

export default {
  name: 'CheckPage',
  props: [
    'locale',
    'checked',
    'submitOnly'
  ],
  computed: {
    getCode () {
      return this.$store.getters['admin/codeList']
    },
    pageList () {
      const sort = 'updateat'
      const pages = this._.cloneDeep(this.pages)
      const list = Sort(pages)
      // filter
      const word = regExp.replaceAllEmpty(this.searchWord.toLowerCase())
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      return list.map(x => {
        const pageData = x.pageData
        return {
          ...x,
          pageData: {
            ...pageData,
            submit: {
              ...pageData.submit,
              ...pageData.submit && {
                isValid: this.validateSubmit(pageData.submit.submitTo)
              }
            }
          }
        }
      }).filter(x => {
        return this.submitOnly
          ? x.pageData.submit && x.pageData.submit.isSubmit
          : x
      }).filter(x => {
        return word.length > 0
          ? regExp.replaceAllEmpty(x.pageData.title.toLowerCase()).includes(word)
          : x
      })
    }
  },
  created () {
    this.$store.dispatch('admin/getCodes')
    this.$store.dispatch('page/setPageListData').then((res) => {
      if (res) {
        this.pages = res
      }
    })
    this.id = UNIQUE.fileid()
  },
  data () {
    let checkedPage = this.checked ? this.checked.map(x => x.pageId) : []
    return {
      id: '',
      pages: [],
      searchWord: '',
      checkedPage
    }
  },
  methods: {
    isEmpty (str) {
      return regExp.replaceAllEmpty(`${str}`).length === 0
    },
    validateSubmit (id) {
      const codeList = this.getCode.map(x => {
        if (x.id) {
          return x.id
        }
      })
      return codeList.includes(id)
    },
    checkAll (e) {
      const isChecked = e.target.checked
      this.checkedPage = isChecked ? this.pageList.map(x => x.pageid) : []
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply)) {
        const pageIds = this.checkedPage.map(x => {
          const page = this.pages.find(p => p.pageid === x)
          return {
            pageId: x,
            title: page.pageData.title,
            subject: page.pageData.submit.subject
          }
        })
        this.$emit('apply', pageIds)
        alert(this.locale.complete_application)
        this.$emit('close')
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.pageList {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .list {
    padding-bottom: 15px;
    border-top: 1px solid $color-lgrey2;
    li {
      padding: 10px 5px 10px 10px;
      border: 1px solid $color-lgrey2;
      border-top: none;
      background-color: $color-white;
    }
  }
}
.searchResult {
  max-height: 100%;
  overflow: auto;
}
.searchInput {
  padding-left: 40px;
  background: $color-white url('~@/assets/img/ico_search.svg') 5px 50% / 20px no-repeat;
}
.btns {
  text-align: center;
  .btn {
    & + .btn {
      margin-left: 15px;
    }
  }
}
.submitTo {
  font-size: 12px;
  color: $color-grey;
}
.stkr {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  font-size: 10px;
  text-align: center;
  line-height: 16px;
  color: $color-white;
  border-radius: 100%;
  background-color: $color-green;
  &.invalid {
    text-decoration: line-through;
    .stkr {
      background-color: $color-red;
    }
  }
}
</style>
